import type {} from '@mui/lab/themeAugmentation'; // see https://mui.com/material-ui/about-the-lab/#typescript
import { theme as baseTheme } from '@swagcharm/kiwi-components';
import type { Theme } from '@mui/material/styles';
const { createTheme } = require('@mui/material/styles');

const theme: Theme = createTheme(baseTheme);

if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  window.theme = theme;
}

export default theme;
